import _i18next from 'i18next';
import isPlainObject from 'lodash.isplainobject';
import createDebug from './debug';
import { loadSomeAssetsConcurrently } from './asset-loaders';
import { FALLBACK_LANGUAGES } from '../constants';

const debug = createDebug('utils:translations');

interface I18nLike {
  addResourceBundle(
    lang: string,
    namespace: string,
    resources: Record<string, unknown>,
    deep: boolean,
    overwrite: boolean
  ): void;
}

export function registerTranslations(
  namespace: string,
  data: Record<string, unknown> = {},
  i18next: I18nLike = _i18next
): void {
  Object.keys(data).forEach((lang) => {
    const value = data[lang];
    if (!isPlainObject(value)) return;
    i18next.addResourceBundle(lang, namespace, value, true, true);
  });
}

export async function loadTranslations(
  urlTemplate: string,
  language: string
): Promise<Record<string, unknown>> {
  const languages = [...new Set([language, ...FALLBACK_LANGUAGES])];
  const translationEntries = languages.map((lang) => ({
    url: urlTemplate.replace('__LANG__', lang),
    type: 'json',
  }));
  let translationDataList: unknown[];

  try {
    translationDataList = await loadSomeAssetsConcurrently(translationEntries);
  } catch (error) {
    debug(error);
    throw new Error('Loading translations failed');
  }

  return languages.reduce<Record<string, unknown>>((result, lang, index) => {
    const data = translationDataList[index];
    return { ...result, [lang]: data instanceof Error ? undefined : data };
  }, {});
}
